var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-avatar',{staticClass:"user-image",class:_vm.image && 'image-hover',attrs:{"text":_vm.name,"src":_vm.image}})
}
var staticRenderFns = []

export { render, staticRenderFns }